module.exports = __webpack_public_path__ + "static/CrearContenido_Mb-1ed52a06a82ab30afbcedc1ecf00bdd8.webp";